import {
  CriterionQuestion,
  EvidenceCardConfig,
} from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { MedicalQuestion } from "../../../data-model/medicalQuestion";

interface SingleCorrectQuestionProps {
  question: MedicalQuestion;
  stepNumber: number | string;
  selectedValue?: string;
  onRadioChange: (value: string) => void;
  evidenceCards?: EvidenceCardConfig[];
  children?: React.ReactNode;
}

const SingleCorrectQuestion = (props: SingleCorrectQuestionProps) => {
  const { question, stepNumber, selectedValue, onRadioChange, evidenceCards } =
    props;

  return (
    <CriterionQuestion
      key={question.id}
      id={question.id}
      stepNumber={stepNumber}
      title={question.question}
      radioName={question.id}
      radioOptions={question.options.map((opt) => ({
        label: opt.text,
        value: opt.id,
      }))}
      radioValue={selectedValue}
      onRadioChange={onRadioChange}
      evidenceCards={evidenceCards}
      collapsible
      defaultExpanded
    >
      {props.children}
    </CriterionQuestion>
  );
};

export default SingleCorrectQuestion;
